import LoadingOverlay from "./loading-overlay";
import DialogOverlay from "./dialog-overlay";

export default {

    install(Vue) {
        Vue.use(LoadingOverlay);
        Vue.use(DialogOverlay);
    },

}
